<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogClient"
    :before-close="doClose"
    width="90%"
    top="5%"
    class="abow_dialog"
  >
    <el-form
      ref="snSelect"
      :model="snSelect"
      class="queryform_div"
      label-width="180px"
    >
      <el-row :gutter="24">
        <el-col :md="8" :xs="24" :sm="24">
          <el-form-item :label="$t('desc.airCompressorSN')">
            <el-input
              v-model="snSelect.value1"
              placeholder=" "
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xs="24" :sm="24">
          <el-form-item :label="$t('title.AirCompressorStatus')">
            <el-select
              v-model="snSelect.value4"
              style="width: 100%"
              :placeholder="$t('desc.select')"
              size="small"
              @change="changeCState"
            >
              <el-option value="全部" :label="$t('desc.all')"></el-option>
              <el-option value="运行" :label="$t('desc.run')"></el-option>
              <el-option value="停机" :label="$t('desc.stop')"></el-option>
              <el-option value="加载" :label="$t('desc.load')"></el-option>
              <el-option value="卸载" :label="$t('desc.Unload')"></el-option>
              <el-option value="警告" :label="$t('tips.warning')"></el-option>
              <el-option value="故障" :label="$t('title.trip')"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="6" :xs="24" :sm="24" style="margin-top: 10px">
         
            <el-button type="primary" @click="onSearchBtn" size="small">{{
              $t("button.query")
            }}</el-button>
            <el-button @click="resetKeyword" size="small">{{
              $t("button.reset")
            }}</el-button> 
        </el-col>
      </el-row>
    </el-form>
    <template>
      <template v-for="item in deviceTable">
        <div
          class="KList"
          style="margin-bottom: 10px"
          @click="openDevice(true, item)"
          :key="item.id"
        >
          <el-row :gutter="24">
          <el-col
              :xs="12"
              :sm="8"
              :md="4"
              style="
                text-align: center;
                padding-left: 15px !important;
                padding-right: 0px !important;
              "
            >
              <img :src="item.imgUrl ? item.imgUrl : k1" style="width: 100%" />
            </el-col>
                <el-col
              :xs="12"
              :sm="16"
              :md="20"
              style="
                border-left: 1px solid #414248;
                padding-left: 30px !important;
                padding-right: 45px !important;
              "
            >
              <div class="header">
                <h4>{{ $t("desc.airCompressorSN") }}：{{ item.dsn }}</h4>
                <el-row :gutter="24" class="info">
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span>{{ $t("title.productLine") }}：</span>{{ item.kType }}
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span>{{ $t("title.productCategories") }}：</span
                    >{{ item.kProduct }}
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span>{{ $t("title.smallClassProduct") }}：</span
                    >{{ item.kSmall }}
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span>{{ $t("title.machineType") }}：</span
                    >{{ item.kPower }}
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span>{{ $t("title.airCompressorService") }}：</span>
                    {{ item.serviceType }}
                  </el-col>
                </el-row>
              </div>
              <div class="body state">
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span
                      >{{ $t("title.AirCompressorStatus") }}：
                      <strong
                        class="numcircle"
                        :style="
                          !item.kstate
                            ? 'background-color:#9ba2ac'
                            : item.kstate.indexOf('警告') != -1
                            ? 'background-color:#EFCA3F'
                            : (item.kstate.indexOf('停机') != -1 || item.kstate.indexOf('故障') != -1)
                            ? 'background-color:#F8454D'
                            : item.kstate.indexOf($t('tips.NA')) != -1
                            ? 'background-color:#9ba2ac'
                            : 'background-color:#62CF88'
                        "
                        >{{
                          item.kstate
                            ? (activeLang=='zh'?item.kstate:$t("desc."+item.kstate.trim()))
                            : $t("tips.NA")
                        }}</strong
                      >
                      <!-- 红色：#F8454D；
                  黄色：#EFCA3F；
                  绿色:#62CF88; -->
                    </span>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span
                      >{{ $t("title.RunningTime") }}：
                      <strong class="numcircle">{{
                        item.kTime ? item.kTime : $t("tips.NA")
                      }}</strong>
                    </span>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6"> 
                    <span
                      >{{ $t("title.DischargePressure") }}：
                      <strong class="numcircle">{{
                        item.dp ? item.dp : $t("tips.NA")
                      }}</strong>
                    </span>
                  </el-col>
                  <el-col :xs="24" :sm="12" :md="6" :lg="6">
                    <span
                      >{{ $t("title.RatedPressure") }}：
                      <strong class="numcircle">{{
                        item.rp ? item.rp : $t("tips.NA")
                      }}</strong>
                    </span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </template>
  </el-dialog>
</template>

<script>
import k1 from "../../../assets/img/img_machine.png";
export default {
  name: "index",
  props: {
    dialogClient: false,
    title: "",
    deviceTable: {
      type: Array,
      default: function () {
        return [];
      },
    },
    customerId: "",
    activeLang:""
  },
  data() {
    return {
      snSelect: {},
      k1: k1,
      deviceTableData: [],
      deviceStatuList: {
        1: "正常",
        2: "报警",
        3: "故障",
      },
    };
  },
  // watch: {
  //   deviceTable: {
  //     handler(newValue, oldValue) {
  //       console.log(newValue);
  //       this.deviceTableData=newValue;
  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    onSearchBtn() {
      this.$emit("onSearchBtn", this.snSelect, this.customerId);
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      //   this.$refs.gsnForm.resetFields();
    },
    openDevice(visible, item) {
      this.$emit("openDevice", visible, item);
    },
    resetKeyword() {
      this.snSelect = {};
      this.changeCState();
    },
    changeCState() {
      var codeList = "";
      if (
        !this.snSelect.value4 ||
        this.snSelect.value4.indexOf(this.$t("desc.all")) != -1
      ) {
        // for (let index = 0; index < this.gatherOption.length; index++) {
        //   codeList.push(this.gatherOption[index].name)
        // }
      } else {
        codeList = this.snSelect.value4;
      }
      this.$emit("changeCState", codeList);
    },
  },
};
</script>

<style>
</style>
